export default function (email: string, password: string, otp?: string) {
  const directus = useNuxtApp().$directus;
  const options = otp ? { otp } : {};
  return directus.login(email, password, options).then(() => useGetUser());
}
